import classNames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import Button from 'ui/base/Button';
import { infoStyle } from 'ui/base/CoreDragger/components/ui.style';
import Tooltip from 'ui/base/Tooltip';

import { StyledDraggerContent } from './UI';
import { renderAllowedMediaTooltip } from './utils/renderAllowedMediaTooltip';

/**
 * @typedef {{
 *  disabled: boolean,
 *  displayMaxSizeMessage: boolean,
 *  extensions: string[],
 *  config: object,
 * }} DraggerContentProps
 */

/**
 * @type {React.FC<DraggerContentProps>}
 */
const DraggerContent = React.forwardRef(({ extensions, config, disabled, displayMaxSizeMessage }, draggerRef) => {
  const buttonRef = React.useRef(undefined);
  const tooltipContent = renderAllowedMediaTooltip(extensions, config, displayMaxSizeMessage);

  React.useImperativeHandle(draggerRef, () => ({
    browse: () => {
      buttonRef.current?.click();
    },
  }), []);

  const handleOnClick = event => {
    event.preventDefault();
  };

  return (
    <StyledDraggerContent>
      <div className="d-flex justify-content-center align-items-center">
        <span className="fb-icon--upload-file" />
      </div>
      <span className="drag-text">
        <FormattedMessage id="page.fiche.medias.drop_here" defaultMessage="Drag & drop your medias here" />
      </span>
      <span className="or-text">
        <FormattedMessage id="or" defaultMessage="Or" />
      </span>
      <Button type="primary" className="mt-2 browse-button" onClick={handleOnClick} ref={buttonRef} disabled={disabled}>
        <FormattedMessage id="browseFiles" defaultMessage="Browse files" />
      </Button>
      {tooltipContent && (
        <Tooltip placement="left" title={tooltipContent}>
          <div className={classNames(infoStyle, 'fb-icon--info text-secondary position-absolute')} />
        </Tooltip>
      )}
    </StyledDraggerContent>
  );
});

export default DraggerContent;
